import React from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MovieCarousel from "../Components/MovieCarousel/MovieCarousel";
import DetailListItem from '../Components/CardItem/CardItem'
import CardItem from "../Components/CardItem/CardItem";
import { ContentStatus } from "../Models/ContentStatus";
import ContentDetails from "../Components/ContentDetails/ContentDetails";
import { ModalMessage } from "../Components/ModalMessage/ModalMessage";


const ComponentViewerPage = () => {
    return (
    <div style={{backgroundColor: '#141414', minHeight: '100vh' }}>
      {/* <div style={{}}>
        <HeaderCarousel />
      </div> */}
      <div style={{ padding: '12px' }}>
        <h4>Card item</h4>
        <CardItem status={ContentStatus.ACTIVE} imageUrl="https://image.tmdb.org/t/p/w500/x2LSRK2Cm7MZhjluni1msVJ3wDF.jpg" />
        <CardItem status={ContentStatus.BLOCKED} imageUrl="https://image.tmdb.org/t/p/w500/x2LSRK2Cm7MZhjluni1msVJ3wDF.jpg" />
        <CardItem status={ContentStatus.AVAILABLE} imageUrl="https://image.tmdb.org/t/p/w500/x2LSRK2Cm7MZhjluni1msVJ3wDF.jpg" />
      </div>
      <div>
        <h4 style={{color: '#FFF'}}>Item da listagem</h4>
        <ContentDetails thumbnailUrl="https://image.tmdb.org/t/p/w500/zrPpUlehQaBf8YX2NrVrKK8IEpf.jpg" title="Titulo" description="Description"></ContentDetails>
      </div>
      <div style={{ padding: '12px' }}>
        <h4 style={{color: '#FFF'}}>Item da listagem</h4>
        <DetailListItem title="Title" description="Description" status={ContentStatus.ACTIVE} imageUrl="https://image.tmdb.org/t/p/w500/ggFHVNu6YYI5L9pCfOacjizRGt.jpg"></DetailListItem>
        <DetailListItem title="Title" description="Description" status={ContentStatus.BLOCKED} imageUrl="https://image.tmdb.org/t/p/w500/x2LSRK2Cm7MZhjluni1msVJ3wDF.jpg"></DetailListItem>
        <DetailListItem title="Title" description="Description" status={ContentStatus.AVAILABLE} imageUrl="https://image.tmdb.org/t/p/w500/reEMJA1uzscCbkpeRJeTT2bjqUp.jpg"></DetailListItem>
      </div>
      <div>
        <h4 style={{color: "#FFF"}}>Carrossel</h4>
          <MovieCarousel />
          <MovieCarousel />
          <MovieCarousel />
      </div>

      <div>
        <ModalMessage 
          title="Titulo"
          description="description"
          leftButtonText="sim"
          leftButtonAction={console.log("leftButtonTapped")}
          rightButtonText="Não"
          rightButtonAction={console.log("rightButtonTapped")}
          ></ModalMessage>
      </div>
    </div>
  );
}

export default ComponentViewerPage;